// +----------------------------------------------------------------------
// | Desc: 全局状态管理库
// +----------------------------------------------------------------------
export default {
    searchType: {
        "100": '查询排放总量',
        "200": '查询排放类型',
        "300": '查询在线车辆',
        "400": '查询今日联单',
        "500": '查询异常联单',
        "600": '查询实时联单'
    },
    orgRole: {
        "100": '堆放角色',
        "200": '处置角色',
        "300": '代理角色',
        "400": '运输角色',
        "500": '分拣角色',
        "600": '排放角色',
        "700": '其他角色'
    },
    orgRoleApp: {
        "100": '堆放端',
        "200": '处置端',
        "300": '代理端',
        "400": '运输端',
        "500": '分拣端'
    },
    filingStatus: {
        "-1": '未备案',
        "100": '待审核',
        "200": '已通过',
        "300": '未通过'
    },
    projectStatus: {
        "100": '审核中',
        "200": '进行中',
        "300": '已结束',
        "400": '已取消',
        "500": '未通过'
    },
    taskStatus: {
        "100": '暂停中',
        "200": '清运中',
        "300": '已结束'
    },
    electronicbill: {
        "100": '出场中',
        "200": '行车中',
        "300": '接收中',
        "400": '已送达'
    },
    projectType: {
        "100": '工地单',
        "200": '整车单',
        "300": '零散单',
        "400": '堆放单',
        "500": '水运单'
    },
    orgUserRoleList: [{
        "value": 100,
        "name": "运营管理"
    }, {
        "value": 200,
        "name": "排放专员"
    }, {
        "value": 300,
        "name": "接收专员"
    }, {
        "value": 400,
        "name": "牌照车司机"
    }, {
        "value": 500,
        "name": "三轮车司机"
    }],

    //资质角色
    zizhiRole: {
        "100": "单位级主体资质",
        "200": "单位级垃圾排放资质",
        "300": "单位级垃圾运输资质",
        "400": "单位级垃圾接收资质",
        "500": "车辆资质",
        "600": "员工资质",
        "700": "船舶资质"
    },
    //资质类型
    zizhiType: {
        //企业资质
        "100": [{
            "value": 100,
            "name": "单位营业执照(企业)"
        }, {
            "value": 101,
            "name": "经营环境图(企业)"
        }, {
            "value": 102,
            "name": "经营定位地图(企业)"
        }, {
            "value": 103,
            "name": "身份证正反照(个人)"
        }, {
            "value": 104,
            "name": "其他证明材料(个人或企业)"
        }],
        //排放资质
        "200": [{
            "value": 201,
            "name": "工地排放证"
        }, {
            "value": 202,
            "name": "备案排放证明"
        }, {
            "value": 203,
            "name": "其他证明材料附件"
        }],
        //运输资质
        "300": [{
            "value": 301,
            "name": "道路运输许可证"
        }, {
            "value": 302,
            "name": "营运证"
        }, {
            "value": 303,
            "name": "运输处置证"
        }, {
            "value": 304,
            "name": "其他证明材料"
        }],
        //接收资料
        "400": [{
            "value": 401,
            "name": "消纳处置证(处置单位)"
        }, {
            "value": 402,
            "name": "回填证件(回填单位)"
        }, {
            "value": 403,
            "name": "码头备案资质(临时码头)"
        }, {
            "value": 404,
            "name": "消纳设备图(所有单位)"
        }, {
            "value": 405,
            "name": "消纳处置能力图(所有单位)"
        }, {
            "value": 406,
            "name": "装卸平台图(所有单位)"
        }, {
            "value": 407,
            "name": "港口经营许可证(临时码头)"
        }, {
            "value": 408,
            "name": "其他证明材料"
        }],
        //车辆资质
        "500": [{
            "value": 501,
            "name": "车辆行驶证"
        }, {
            "value": 502,
            "name": "车辆营运证"
        }, {
            "value": 503,
            "name": "车辆标识卡"
        }, {
            "value": 504,
            "name": "其他证明材料"
        }],
        //员工资质
        "600": [{
            "value": 601,
            "name": "身份证正反照"
        }, {
            "value": 602,
            "name": "驾驶证件照片"
        }, {
            "value": 603,
            "name": "其他证明材料"
        }],
        //船舶资质
        "700": [{
            "value": 701,
            "name": "内河船舶安全与环保证书"
        }, {
            "value": 702,
            "name": "船舶营运证"
        }, {
            "value": 703,
            "name": "其他证明材料"
        }]
    },
    //资质角色
    zizhiTypeTxt: {
        // 企业资质
        "100": "单位营业执照",
        "101": "经营环境图",
        "102": "经营定位地图",
        "103": "身份证正反照",
        "104": "其他证明材料",

        // 排放资质
        "201": "工地排放证",
        "202": "备案排放证明",
        "203": "其他证明材料",

        // 运输资质
        "301": "道路运输许可证",
        "302": "营运证",
        "303": "运输处置证",
        "304": "其他证明材料",

        // 接收资料
        "401": "消纳处置证",
        "402": "回填证件",
        "403": "码头备案资质",
        "404": "消纳设备图",
        "405": "消纳处置能力图",
        "406": "装卸平台图",
        "407": "港口经营许可证",
        "408": "其他证明材料",

        // 车辆资质
        "501": "车辆行驶证",
        "502": "车辆营运证",
        "503": "车辆标识卡",
        "504": "其他证明材料",

        // 员工资质
        "601": "身份证正反照",
        "602": "驾驶证件照片",
        "603": "其他证明材料",

        // 船舶资质
        "701": "内河船舶安全与环保证书",
        "702": "船舶营运证",
        "703": "其他证明材料"
    },

}